"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _utils = require("../../utils");
function Tooltip(_ref) {
  let {
    placement = 'top-start',
    title,
    children
  } = _ref;
  const [open, setOpen] = _react.default.useState(false);
  const {
    isMobile
  } = (0, _utils.useDeviceInfo)();
  const theme = (0, _material.useTheme)();
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = event => {
    if (event.type === 'click' || event.type === 'mouseover' && !isMobile) {
      setOpen(true);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    onOpen: handleTooltipOpen,
    onClose: handleTooltipClose,
    open: open,
    placement: placement,
    sx: {
      maxWidth: isMobile ? '342px' : '464px',
      '& .MuiTooltip-arrow': {
        color: theme.palette.TwClrBaseGray800
      },
      '& .MuiTooltip-tooltip': {
        backgroundColor: theme.palette.TwClrBaseGray800,
        color: theme.palette.TwClrBaseWhite,
        padding: '8px',
        '& a': {
          color: theme.palette.TwClrBaseWhite
        }
      }
    },
    title: title
  }, /*#__PURE__*/_react.default.createElement("span", {
    onClick: handleTooltipOpen
  }, children));
}